const sections = {
  dashboard: {
    id: 'btn_db_expediente',
    icon: 'iDocIcon-home-dashboard',
    title: 'SECTIONS.DASHBOARD'
  },
  masters: {
    id: 'btn_masters',
    icon: 'iDocIcon-admin-tools',
    title: 'SECTIONS.MASTERS'
  },
  'dashboard-tasks': {
    id: 'btn_db_tasks',
    icon: 'iDocIcon-list-check-formalities',
    title: 'SECTIONS.TASKS'
  },
  search: {
    id: 'btn_db_search',
    icon: 'iDocIcon-search',
    title: 'SECTIONS.SEARCH_V2'
  },
  importExportFile: {
    id: 'btn_import_export_file',
    icon: 'iDocIcon-ImportExport',
    title: 'SECTIONS.IMPORT_EXPORT_FILE'
  },
  reports: {
    id: 'btn_db_reports',
    icon: 'iDocIcon-reports-chart-bar',
    title: 'SECTIONS.REPORTS'
  },
  iDocSign: {
    id: 'btn_iDocSign',
    icon: 'iDocIcon-signature-draw',
    title: 'SECTIONS.IDOCSIGN'
  },
  configuration: {
    id: 'btn_db_configuration',
    icon: 'ico-cog',
    title: 'SECTIONS.CONFIGURATION',
    sections: {
      'admin-role': {
        id: 'btn_db_rol_permisos',
        icon: 'ico-unlock',
        title: 'SECTIONS.ADMIN_ROLE'
      },
      'admin-user': {
        id: 'btn_db_usuarios',
        icon: 'ico-users',
        title: 'SECTIONS.ADMIN_USER'
      },
      'admin-uo': {
        id: 'btn_units',
        icon: 'ico-uo',
        title: 'SECTIONS.UNITS'
      },
      masters: {
        id: 'btn_masters',
        icon: 'ico-uo',
        title: 'SECTIONS.MASTERS'
      }
    }
  },
  jiraServiceDesk: {
    id: 'btn_jiraServiceDesk',
    icon: 'iDocIcon-serviceDesk',
    title: 'SECTIONS.JIRA_SERVICE_DESK'
  },
  faq: {
    id: 'btn_faq',
    icon: 'iDocIcon-FAQ',
    title: 'SECTIONS.FAQ'
  },
  management: {
    id: 'btn_management',
    icon: 'iDocIcon-Management',
    title: 'SECTIONS.MANAGEMENT'
  }
}

export default sections
